// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"163":"Popup-next","195":"Popupv2","508":"Embed-next","666":"Embed","855":"Popup"}[chunkId] || chunkId) + "." + {"155":"e8be42c4","163":"c9b765f4","183":"99e2a292","195":"933940bd","508":"295903f5","509":"5973acfb","576":"6f5686d1","591":"f9485e21","666":"29e26c44","855":"7fc8cbf9"}[chunkId] + ".chunk.js";
};